class EventQueue {
  private subscribers: Record<string, (data: unknown) => void> = {};

  subscribe(eventName: string, callback: (data: unknown) => void) {
    this.subscribers[eventName] = callback;
  }

  unsubscribe(eventName: string) {
    delete this.subscribers[eventName];
  }

  publish(eventName: string, data: unknown) {
    this.subscribers[eventName]?.(data);
  }
}

export const eventQueue = new EventQueue();
